export { SplashLayoutRoute } from './splash-layout';
